module.exports = __webpack_public_path__ + "media/integrations/magento-19af9687.svg";